export const ROLE_NAMES = {
  admin: 'Admin',
  client: 'Client',
  partner: 'Partner',
  partner_admin: 'Partner admin',
  company_admin: 'Company admin',
};
